import classNames from 'classnames';

import { Pages } from 'modules/navigation/domain/enums/pages';
import React, { forwardRef, useMemo } from 'react';
import { useLingui } from '@lingui/react/macro';
import { useLocation, useMatch } from 'react-router-dom';
import UDTabs from 'ud-ui/components/tabs';
import { Tab } from 'ud-ui/components/tabs/interfaces';
import UDText from 'ud-ui/components/text';
import { TeamViewTab } from 'modules/teams/domain/enums/team-view-tab';
import { TEAM_VIEW_TABS } from './constants';

type CreateEditFormParams = {
  tab: Tab;
  count?: number;
  isActive?: boolean;
  subLabel?: string;
  state?: any;
};

const createEditFormTab = (params: CreateEditFormParams): Tab => {
  const { tab, count, isActive, subLabel, state } = params;

  if (count !== undefined) {
    const badgeBgColor = isActive ? 'bg-surfaceWhite' : 'bg-accentNaplesYellow';
    const className = classNames([
      'text-surfaceRaisinBlack50',
      badgeBgColor,
      'p-1',
      'rounded-[4px]',
      'ml-2',
      'line-height-1',
      'caption-1',
    ]);

    return {
      hash: tab.hash,
      label: (
        <>
          {tab.label}{' '}
          <UDText type="subhead" className={className}>
            {count}
          </UDText>
        </>
      ),
    };
  }

  return { ...tab, subLabel, state };
};

type TeamEditFormTabsProps = {
  state?: any;
};

const TeamEditFormTabs = forwardRef<HTMLDivElement, TeamEditFormTabsProps>(({ state }, ref) => {
  const { t } = useLingui();
  const location = useLocation();
  const activeTab = (location.hash || '').split('/')[0];
  const createNewPlayer = useMatch(`${Pages.TEAMS.EDIT}/players/create`);

  const tabs = useMemo(() => {
    return TEAM_VIEW_TABS.map((tab) =>
      createEditFormTab({
        tab: { hash: tab.hash, label: t(tab.label) },
        isActive: tab.hash === activeTab,
        subLabel: tab.hash === TeamViewTab.PLAYERS && createNewPlayer ? t`Добавление игрока` : undefined,
        state: state,
      }),
    );
  }, [t, activeTab, createNewPlayer, state]);

  return <UDTabs tabs={tabs} defaultTab={tabs[0]} ref={ref} activeRoutePattern={Pages.TEAMS.EDIT} />;
});

export default TeamEditFormTabs;
